import { render, staticRenderFns } from "./ListConsignments.vue?vue&type=template&id=c2e556c0"
import script from "./ListConsignments.vue?vue&type=script&lang=js"
export * from "./ListConsignments.vue?vue&type=script&lang=js"
import style0 from "./ListConsignments.vue?vue&type=style&index=0&id=c2e556c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports